export const SET_ALL_FROMJSON = 'SET_ALL_FROMJSON';
export const SET_NEXT_ID = 'SET_NEXT_ID';
export const RESET_STATE = 'RESET_STATE';
